<template>
<b-form-group :label="label">
	<div class="row no-gutters">
		<div v-bind:class="{ 'col-sm-10': deletable, 'col-sm-12' : !deletable }">
			<multiselect v-model="currentSelection"
			             @input="itemHasChanged"
			             @search-change="(query) => getAutocomplete(request, query)"
			             track-by="id"
			             :custom-label="customLabel"
			             :loading="isLoading"
			             :options-limit="100"
			             :searchable="searchable"
			             :internal-search="internalSearch"
			             :options="store.data"
			             :selectLabel="selectLabel"
			             :selectedLabel="selectedLabel"
			             :deselectLabel="deselectLabel"
			             :placeholder="placeholderLabel"
			             :allow-empty="allowEmpty"
			             :reset-after="resetAfter"
			             :hide-selected="hideSelected"
			             v-bind:class="{ 'deletable' : deletable }">
			</multiselect>
		</div>

		<div v-if="deletable" class="col-sm-2">
			<b-button
				@click="removeSelection"
				class="autocomplete--wipe h-100"
				variant="outline-danger"
			>
				<i class="fa fa-eraser" aria-hidden="true"></i>
			</b-button>
		</div>
	</div>

</b-form-group>
</template>
<script>
import { isNil } from 'lodash';
import { CancelToken } from 'axios';
import Multiselect from 'vue-multiselect';

class Store {
	constructor() {
		this.data = [];
	}

	setData(data = []) {
		this.data = data;
	}
}

export default {
	name: 'base-autocomplete',
	components: {
		Multiselect
	},
	data() {
		const store = new Store();

		return {
			isLoading: false,
			error: null,
			requestSource: null,
			store: store,
			currentSelection: null
		}
	},
	props: {
		selected: {
			type: Object,
			default: null
		},
		label: {
			type: String,
			default: 'Item'
		},
		searchable: {
			type: Boolean,
			default: true
		},
		selectLabel: {
			type: String,
			default: 'Selecteer'
		},
		selectedLabel: {
			type: String,
			default: 'Geselecteerd'
		},
		deselectLabel: {
			type: String,
			default: 'Verwijderen'
		},
		placeholderLabel: {
			type: String,
			default: 'Zoek'
		},
		internalSearch: {
			type: Boolean,
			default: false
		},
		deletable: {
			type: Boolean,
			default: true
		},
		allowEmpty: {
			type: Boolean,
			default: true
		},
		resetAfter: {
			type: Boolean,
			default: false
		},
		hideSelected: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		selected: {
			handler() {
				this.setSelection();
			},
			deep: false
		}
	},
	methods: {
		customLabel(item) {
			return item.name;
		},
		itemHasChanged(data) {
			this.$emit('update:item', data);
		},
		request() {
			return () => {
				return Promise(
					(resolve, reject) => {
						resolve([]);
					}
				);
			}
		},

		removeSelection() {
			this.currentSelection = null;
			this.itemHasChanged(null);
		},

		setSelection() {
			this.currentSelection = this.selected;
		},

		getAutocomplete(request, query) {
			if (!isNil(this.requestSource)) {
				this.requestSource.cancel();
			}

			this.isLoading = true;
			this.requestSource = CancelToken.source();

			this.request().call(this, { query: query }, this.requestSource.token)
				.then(data => {
					this.store.setData(data.data);
					this.isLoading = false;
				})
				.catch(error => {
					this.error = error;
					this.isLoading = false;
				});
		}
	},
	mounted() {
		this.setSelection();
	}
}
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// BaseAutocomplete.vue?a5fa06f0